export const toggleHtmlClass = (className) => {
  document.querySelectorAll('html')[0].className = className
}
